(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tekkao-boutique-colors')) {
    customElements.define('tekkao-boutique-colors', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const form = this.closest('form');
        const submit = form?.querySelector('button[type="submit"]');
        if (!form || !submit) return;
        if (!submit.hasAttribute('data-boutique-unavailable')) submit.dataset.boutiqueUnavailable = String(submit.disabled);
        const unavailable = submit.dataset.boutiqueUnavailable === 'true';
        const max = Number(this.dataset.max);
        const buttons = [...this.querySelectorAll('[data-color]')];
        const counts = new Map(buttons.map(b => [b.dataset.color, 0]));
        const render = () => {
          const picks = [];
          const recap = [];
          buttons.forEach(b => {
            const n = counts.get(b.dataset.color);
            b.setAttribute('aria-pressed', String(n > 0));
            b.querySelector('[data-qty]').textContent = n ? '×' + n : '';
            if (n) recap.push(b.children[1].textContent + ' ×' + n);
            for (let i = 0; i < n; i++) picks.push(b.dataset.color);
          });
          this.querySelector('[data-count]').textContent = picks.length + '/' + max;
          const summary = this.querySelector('[data-recap]');
          summary.textContent = recap.join(' · ');
          summary.hidden = !picks.length;
          form.querySelectorAll('[data-boutique-property]').forEach(i => i.remove());
          picks.forEach((color, index) => {
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = 'properties[Couleur sac ' + (index + 1) + ']';
            input.value = color;
            input.dataset.boutiqueProperty = '';
            form.appendChild(input);
          });
          submit.disabled = unavailable || picks.length !== max;
        };
        this.addEventListener('click', event => {
          event.stopPropagation();
          const button = event.target.closest('[data-color]');
          if (!button || !this.contains(button)) return;
          const total = [...counts.values()].reduce((a, b) => a + b, 0);
          const color = button.dataset.color;
          const n = counts.get(color);
          if (total < max) counts.set(color, n + 1);
          else if (n > 0) counts.set(color, n - 1);
          render();
        }, { signal: this.controller.signal });
        form.addEventListener('submit', event => {
          if ([...counts.values()].reduce((a, b) => a + b, 0) !== max) {
            event.preventDefault();
            event.stopImmediatePropagation();
          }
        }, { capture: true, signal: this.controller.signal });
        render();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
